import { makeStyles } from "@material-ui/core";

const useGlobalStyles = makeStyles({
  link: {
    textDecoration: "none",
  },
});

export default useGlobalStyles;
